
<template>
  <div class="company">
    <confirm ref="confirm"></confirm>
    <v-progress-linear
      v-show="progressBar"
      slot="progress"
      color="blue"
      indeterminate
    />

    <v-container class="my-1">
      <v-layout row Wrap>
        <v-flex xs12 sm12 lg12
          ><v-card-text
            v-text="PageTitle"
            class="subtitle-1 indigo--text"
          ></v-card-text>
        </v-flex>
      </v-layout>

      <v-layout row Wrap>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs2 sm3 lg2>
          <v-card-actions>
            <v-btn
              color="blue darken-1"
              text
              @click="editnow"
              :disabled="WhenEdit"
              v-bind:class="{
                'd-none': WhenEdit || this.$route.params.Activity_id == '0',
              }"
            >
              <v-icon>mdi-pencil</v-icon>
              Edit
            </v-btn>

            <v-btn
              color="green darken-1"
              text
              @click="savenow"
              :disabled="!WhenEdit"
              v-bind:class="{ 'd-none': !WhenEdit }"
            >
              <v-icon>mdi-update</v-icon>
              Save
            </v-btn>
          </v-card-actions>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs3 sm3 lg2>
          <v-card-actions>
            <v-btn
              color="green darken-1"
              text
              @click="addnewnow"
              :disabled="WhenEdit"
              v-bind:class="{ 'd-none': WhenEdit }"
            >
              <v-icon>mdi-new-box</v-icon>
              New
            </v-btn>
          </v-card-actions>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>

        <v-flex xs2 sm3 lg2>
          <v-card-actions>
            <v-btn
              color="red darken-1"
              text
              @click="deletenow"
              :disabled="WhenEdit"
              v-bind:class="{ 'd-none': WhenEdit }"
            >
              <v-icon>mdi-delete</v-icon>
              Delete
            </v-btn>

            <v-btn
              color="orange darken-1"
              text
              @click="cancelnow"
              :disabled="!WhenEdit"
              v-bind:class="{ 'd-none': !WhenEdit }"
            >
              <v-icon>mdi-cancel</v-icon>
              Cancel
            </v-btn>
          </v-card-actions>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm11 lg8>
          <v-text-field
            v-model="Company_Name"
            label="Company"
            class="text-Readonly"
            readonly
            filled
            disabled
          >
            <template v-slot:append>
              <v-btn
                color="blue darken-1"
                text
                @click="gotocompany"
                :disabled="WhenEdit"
              >
                <v-icon>mdi-magnify</v-icon>
                show
              </v-btn>
            </template>
          </v-text-field>
          
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm3 lg2>
          <v-text-field
            v-model="Adate"
            label="Date"
            type="date"
            :disabled="!WhenEdit"
          ></v-text-field>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm3 lg2>
          <v-select
            v-model="Atype"
            :items="Atypes"
            label="Type"
            :disabled="!WhenEdit"
          ></v-select>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm3 lg2 align-self-center>
          <v-checkbox
            v-model="Acompleted"
            label="Completed"
            :disabled="!WhenEdit"
          ></v-checkbox>
        </v-flex>

        <v-flex xs1 sm1 lg1> </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm11 lg8>
          <v-textarea v-model="Anote" label="Notes" :disabled="!WhenEdit">
          </v-textarea>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm3 lg2>
          <v-text-field
            v-model="Createddate"
            label="Created Date"
            disabled
          ></v-text-field>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm3 lg2>
          <v-text-field
            v-model="Lastupdby"
            label="Last Updated By"
            disabled
          ></v-text-field>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm3 lg2>
          <v-text-field v-model="Lastupddate" label="Last Update" disabled>
          </v-text-field>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container>
      <v-layout row Wrap>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm11 lg11
          ><v-card-text
            v-text="AudienceTitle"
            class="subtitle-1 grey--text"
          ></v-card-text>
        </v-flex>
      </v-layout>

      <v-layout row Wrap>
        <v-flex xs1 sm1 lg1> </v-flex>

        <v-flex xs11 sm11 lg8>
          <v-data-table
            class="grey--text"
            :headers="actheaders"
            :items="Activities"
            item-key="Activity_id"
            :hide-default-footer="true"
            :disable-pagination="true"
            :disable-sort="true"
            :disable-filtering="true"
            @click:row="gotoaudience"
          ></v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>



<script>
// @ is an alias to /src
import Confirm from "@/components/Confirm";
export default {
  watch: {
    $route() {
      this.refreshlist();
    },
  },
  components: { Confirm },
  data() {
    return {
      WhenEdit: false,
      DataReady: false,
      PageTitle: localStorage.getItem("CURPROFILE") + " Company Activities",
      AudienceTitle: "Activity History",
      Company_ID: 0,
      Activity_id: 0,
      Company_Name: "",
      Adate: "",
      Atype: "",
      Anote: "",
      Acompleted: "",
      Createddate: "",
      Lastupdby: "",
      Lastupddate: "",
      Atypes: [],
      Activities: [],
      allowedit: false,
    };
  },

  computed: {
    actheaders() {
      return [
        { text: "Date", value: "Adate" },
        { text: "Type", value: "Atype" },
        { text: "Notes", value: "Anote" },
        { text: "Completed", value: "Acompleted" },
        { text: "Last Update", value: "Lastupdby" },
        { text: "Last Update", value: "Lastupddate" },
        { text: "Cteated", value: "Createddate" },
      ];
    },
  },

  created() {
    this.refreshlist();
  },

  methods: {
    async refreshlist() {
      this.progressBar = true;
      this.DataReady = false;
      this.activities = [];
      this.myJsonResp = await this.PostData(
        "GetActivity",
        JSON.stringify({
          curprofile: localStorage.getItem("CURPROFILE"),
          Company_ID: this.$route.params.Company_ID,
          Activity_id: this.$route.params.Activity_id,
        })
      );
      this.progressBar = false;
      if (this.myJsonResp != "ERROR") {
        this.data = JSON.parse(this.myJsonResp);
        this.Company_ID = this.$route.params.Company_ID;
        this.Activity_id = this.$route.params.Activity_id;
        this.Company_Name = this.data.Company_Name;
        this.Adate = this.data.Adate;
        this.Atype = this.data.Atype;
        this.Anote = this.data.Anote;
        this.Acompleted = this.data.Acompleted;
        this.Createddate = this.data.Createddate;
        this.Lastupdby = this.data.Lastupdby;
        this.Lastupddate = this.data.Lastupddate;
        this.Activities = this.data["ACTIVITIES"];
        this.Atypes = this.data["ATYPES"];
        this.allowedit = this.data.Allowedit;
        this.WhenEdit = false;
        this.DataReady = true;

        if (this.$route.params.Activity_id == 0) {
          this.editnow();
        }
      }
    },
    async editnow() {
      if (this.allowedit == false) {
        await this.$refs.confirm.open(
          "Security",
          "Access Denied !",
          "",
          "Close",
          { color: "error" }
        );
        return;
      }

      this.WhenEdit = !this.WhenEdit;
    },

    async cancelnow() {
      this.WhenEdit = false;
      //this.refreshlist();
    },

    addnewnow() {
      this.$router.push(
        "/Activity/" + this.$route.params.Company_ID + "/Activity_id/0"
      );
      this.refreshlist();
    },

    gotoaudience(row) {
      this.$router.push(
        "/Activity/" +
          this.$route.params.Company_ID +
          "/Activity_id/" +
          row.Activity_id
      );
      this.refreshlist();
    },
    async deletenow() {
      if (this.allowedit == false) {
        await this.$refs.confirm.open(
          "Security",
          "Access Denied !",
          "",
          "Close",
          { color: "error" }
        );
        return;
      }

      if (
        await this.$refs.confirm.open("Confirm", "Delete ?", "Yes", "No", {
          color: "error",
        })
      ) {
        this.progressBar = true;
        this.DataReady = false;
        this.myJsonResp = await this.PostData(
          "DeleteActivity",
          JSON.stringify({
            curprofile: localStorage.getItem("CURPROFILE"),
            Company_ID: this.$route.params.Company_ID,
            Activity_id: this.$route.params.Activity_id,
          })
        );
        this.progressBar = false;
        this.DataReady = true;
        if (this.myJsonResp != "ERROR") {
          this.data = JSON.parse(this.myJsonResp);
          await this.$refs.confirm.open("Information", "Deleted", "Close", "", {
            color: "info",
          });
          await this.$router.replace({
            path:
              "/Activity/" +
              this.data.Company_ID +
              "/Activity_id/" +
              this.data.Activity_id,
          });
         
        }
      }
    },

    gotocompany() {
      this.$router.push("/Company/" + this.Company_ID);
    },


    async savenow() {
      this.progressBar = true;
      this.DataReady = false;
      this.myJsonResp = await this.PostData(
        "SaveActivity",
        JSON.stringify({
          curprofile: localStorage.getItem("CURPROFILE"),
          Company_ID: this.$route.params.Company_ID,
          Activity_id: this.$route.params.Activity_id,
          Adate: this.Adate,
          Atype: this.Atype,
          Acompleted: this.Acompleted,
          Anote: this.Anote,
        })
      );
      this.progressBar = false;
      this.DataReady = true;
      if (this.myJsonResp != "ERROR") {
        this.WhenEdit = !this.WhenEdit;
        await this.$refs.confirm.open(
          "Information",
          "Activity saved",
          "Close",
          "",
          {
            color: "info",
          }
        );
        this.data = JSON.parse(this.myJsonResp);
        if (this.$route.params.Activity_id == 0) {
          await this.$router.replace({
            path:
              "/Activity/" +
              this.data.Company_ID +
              "/Activity_id/" +
              this.data.Activity_id,
          });
        }
        await this.refreshlist();
      }
    },
  },
};
</script>